/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { NotificationsEmailTokenResponseErrorSchema } from './NotificationsEmailTokenResponseErrorSchema';
import {
    NotificationsEmailTokenResponseErrorSchemaFromJSON,
    NotificationsEmailTokenResponseErrorSchemaFromJSONTyped,
    NotificationsEmailTokenResponseErrorSchemaToJSON,
} from './NotificationsEmailTokenResponseErrorSchema';
import type { NotificationsEmailTokenResponseSchema } from './NotificationsEmailTokenResponseSchema';
import {
    NotificationsEmailTokenResponseSchemaFromJSON,
    NotificationsEmailTokenResponseSchemaFromJSONTyped,
    NotificationsEmailTokenResponseSchemaToJSON,
} from './NotificationsEmailTokenResponseSchema';

/**
 * 
 * @export
 * @interface NotificationsEmailTokenResponse
 */
export interface NotificationsEmailTokenResponse {
    /**
     * 
     * @type {string}
     * @memberof NotificationsEmailTokenResponse
     */
    token: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationsEmailTokenResponse
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationsEmailTokenResponse
     */
    message: string;
}

/**
 * Check if a given object implements the NotificationsEmailTokenResponse interface.
 */
export function instanceOfNotificationsEmailTokenResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "token" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "message" in value;

    return isInstance;
}

export function NotificationsEmailTokenResponseFromJSON(json: any): NotificationsEmailTokenResponse {
    return NotificationsEmailTokenResponseFromJSONTyped(json, false);
}

export function NotificationsEmailTokenResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationsEmailTokenResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'token': json['token'],
        'email': json['email'],
        'message': json['message'],
    };
}

export function NotificationsEmailTokenResponseToJSON(value?: NotificationsEmailTokenResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token': value.token,
        'email': value.email,
        'message': value.message,
    };
}

